export const SET_STATE_DISABLE = 'SET_STATE_DISABLE';

export const setStateDisable = value => {
  return {
    type: SET_STATE_DISABLE,
    payload: value
  };
};